export default async function loadAppSettings(
  reference: string,
  theme: any,
  config: any,
  callback: () => void
) {
  const start = Date.now();
  if (reference) {
    await Promise.all([
      theme.fetchBranding(reference),
      config.fetchAccountSettings(reference),
    ]);
  }
  const end = Date.now();
  if (end - start < 2000) {
    setTimeout(() => callback(), 2000 - (end - start));
  } else {
    callback();
  }
}
